import React, { useState } from 'react';

// components
import SearchInputComponent from '../../../../../ui/SearchInput/SearchInputComponent';

/// ui components
import CustomAddNewButton from '../../../../../ui/CustomAddNewButton/CustomAddNewButton';

// prime react
import { Dropdown } from "primereact/dropdown";
import { Calendar } from 'primereact/calendar';
import CustomCancelbtn from '../../../../../ui/CustomCancelbtn/CustomCancelbtn';

// styles
import "./../documentCategories.scss";

const FilterBar = (props) => {
    const { activeIndex, setActiveIndex, activeTabData, keyword, setKeyword, isRangeShow, setIsRangeShow, selectedDateFilter, setSelectedDateFilter, dates2, setDates2 } = props

    const handleDateFilterChange = (event) => {
        if (event.value === "dateRange") {
            setIsRangeShow(true);
            setSelectedDateFilter(event.value);
        }
        setSelectedDateFilter(event.value);
    };

    const datefilteroption = [
        { name: "Last 24 Hours", value: "24hours" },
        { name: "Last 7 Days", value: "7days" },
        { name: "Last 30 Days", value: "30days" },
        { name: "Last 90 Days", value: "90days" },
        { name: "Date Range", value: "dateRange" },
    ];

    return (
        <div>
            <div className="grid">
                <div className="col-12 md:col-10">
                    <h4 className="pl-2">
                        <b>Documents</b>
                    </h4>
                    <div className='categories-container'>
                        {
                            activeTabData?.underWritingTab?.activeTabIndex === activeIndex ?
                                <CustomAddNewButton
                                    type="button"
                                    title="Underwriting"
                                    onClick={() => setActiveIndex(0)}
                                    className="category-button"
                                /> :
                                <CustomCancelbtn type='button' className='custom-width-doc-categories mr-0 ' onClick={() => setActiveIndex(0)} title="Underwriting" />
                        }

                        {
                            activeTabData?.invoicesTab?.activeTabIndex === activeIndex ?
                                <CustomAddNewButton
                                    type="button"
                                    title="Invoices"
                                    onClick={() => setActiveIndex(1)}
                                    className="category-button"
                                /> :
                                <CustomCancelbtn type='button' className='custom-width-doc-categories mr-0 ' onClick={() => setActiveIndex(1)} title="Invoices" />
                        }
                        {
                            activeTabData?.collectionsTab?.activeTabIndex === activeIndex ?
                                <CustomAddNewButton
                                    type="button"
                                    title="Collections"
                                    onClick={() => setActiveIndex(2)}
                                    className="category-button"
                                /> :
                                <CustomCancelbtn type='button' className='custom-width-doc-categories mr-0 ' onClick={() => setActiveIndex(2)} title="Collections" />
                        }


                    </div>
                </div>

                <div className="md:col-7 col-12"></div>
                <div className="md:col-5 col-12">
                    <div className="flex flex-row">
                        <div className="mr-3 w-100">
                            <SearchInputComponent type="text" value={keyword} setKeyword={setKeyword} placeholder="Search by Document Title" />
                        </div>
                        {isRangeShow ? (
                            <div className="w-100  doc-cate-date-filter">
                                {isRangeShow ? (
                                    <span
                                        onClick={() => {
                                            setIsRangeShow(false);
                                            setSelectedDateFilter("30days");
                                            setDates2(null);
                                        }}
                                        className='cross_icon_date-date-picker '

                                    >
                                        x
                                    </span>
                                ) : (
                                    ""
                                )}
                                <Calendar
                                    inputClassName='p-3'
                                    id="range"
                                    value={dates2}
                                    onChange={(e) => {
                                        setDates2(e.value);
                                        e.preventDefault();
                                    }}
                                    selectionMode="range"
                                    readOnlyInput
                                    showIcon
                                    placeholder="mm/dd/yyyy"
                                    mask="99/99/9999"
                                    monthNavigator
                                    yearNavigator
                                    yearRange="1945:2050"
                                />
                            </div>
                        ) : (
                            <Dropdown
                                id="datefilter"
                                name="datefilter"
                                options={datefilteroption}
                                optionLabel="name"
                                optionValue="value"
                                value={selectedDateFilter}
                                className="p-1"
                                placeholder="Select"
                                onChange={handleDateFilterChange}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FilterBar;